
import { useEffect } from 'react';
import { preloadRoute } from './routePreloadRegistry';

// List of critical routes that should be prefetched early
export const criticalRoutes = [
  '/dashboard',
  '/investor-directory',
  '/templates',
  '/deal-room',
  '/investor-intelligence'
];

// List of routes by user context
export const contextualRoutes: Record<string, string[]> = {
  'dashboard': ['/investor-directory', '/pitch-analyzer', '/templates'],
  'investor-directory': ['/investor-crm', '/investor-intelligence'],
  'templates': ['/financial-model-template', '/pitch-deck-generator'],
  'investor-crm': ['/investor-directory', '/deal-room'],
};

/**
 * Prefetch routes based on current route context
 * This helps anticipate user navigation patterns
 */
export const prefetchContextualRoutes = (currentRoute: string) => {
  // Extract the route name without slashes
  const routeKey = currentRoute.replace(/^\//, '').split('/')[0];
  
  // Get contextual routes for current location
  const routesToPrefetch = contextualRoutes[routeKey] || [];
  
  // Prefetch them with slight delay and staggered timing
  routesToPrefetch.forEach((route, index) => {
    setTimeout(() => {
      preloadRoute(route);
    }, 300 + (index * 150)); // Staggered loading to distribute network requests
  });
};

/**
 * Prefetch critical routes during idle time
 */
export const prefetchCriticalRoutes = () => {
  // Only run in browser
  if (typeof window === 'undefined') return;

  const prefetchWithIdleCallback = () => {
    criticalRoutes.forEach((route, index) => {
      setTimeout(() => {
        preloadRoute(route);
      }, index * 200); // Stagger prefetching to avoid network congestion
    });
  };

  // Use requestIdleCallback when available, otherwise use setTimeout
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(prefetchWithIdleCallback);
  } else {
    setTimeout(prefetchWithIdleCallback, 2000); // Wait 2 seconds before prefetching
  }
};
